var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.displayAvgFeedback)?_c('v-card',{staticClass:"text-center"},[(_vm.displayAvgFeedback)?_c('v-card-text',{staticClass:"d-inline-block black--text body-1"},[_c('p',{staticStyle:{"font-size":"20px","margin-bottom":"0px"},domProps:{"innerHTML":_vm._s(_vm.getUFFb('goalAVG'))}})]):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }